/* eslint-disable jsx-a11y/alt-text */
import Icon from "@common/Icon";
import Drawer from "@components/shared/Drawer";
import AppContext from "@helpers/context";
import { IProduct } from "@interfaces/product";
import {
  IRowsKey,
  Notifications,
  Progress,
  ViewRowInterchange,
} from "d-react-components";
import { useFormik } from "formik";
import { join, map } from "lodash";
import { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ProductInputSku from "../input/ProductInputSku";
import { useParams } from "react-router-dom";
import { editProduct } from "@network/api/product";

interface IProductDetailSku {
  open: boolean;
  defaultValue?: any;
  onUpdated: any;
  onClose: () => void;
}

const ProductDetailSkuDrawer = ({
  open,
  defaultValue,
  onUpdated,
  onClose,
}: IProductDetailSku) => {
  const { t } = useTranslation();
  const { productId } = useParams();

  const productForm = useFormik<any>({
    initialValues: defaultValue as any,
    validateOnChange: false,
    validateOnBlur: false,
    // validationSchema: schema,
    onSubmit: (values: any) => {
      onUpdateProduct(values);
    },
  });
  const formValues = productForm?.values;
  const formErrors = productForm?.errors;

  const onUpdateProduct = (values: any) => {
    const { aliasSkuList, sku } = values;

    const body = {
      productid: productId,
      sku,
      alias_sku: map(aliasSkuList, (item) => item.value),
    };

    Progress.show(
      {
        method: editProduct,
        params: [body],
      },
      (res: any) => {
        Notifications.showSuccess(t("updateSuccess"));
        onUpdated();
        onClose();
      }
    );
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("sku")}
      size="auto"
      width="80vw"
      onSave={() => {
        productForm.handleSubmit();
      }}
    >
      <div>
        <ProductInputSku productForm={productForm} />
      </div>
    </Drawer>
  );
};

const ProductDetailSku = () => {
  const { productDetail, loadProductDetail } = useContext(AppContext);
  const [openEdit, setOpenEdit] = useState(false);
  const { t } = useTranslation();

  const DETAILS_KEY = useMemo<IRowsKey<IProduct>[]>(
    () => [
      {
        id: "sku",
        label: t("sku"),
      },
      {
        id: "aliasSkuList",
        label: t("aliasSku"),
        renderContent: ({ data, item }) => {
          return (
            <div className="flex-column">
              {join(
                map(data, (alias) => alias.value),
                ", "
              )}
            </div>
          );
        },
      },
    ],
    [t]
  );

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mt-3">
        <h5>{t("sku")}</h5>
        <span onClick={() => setOpenEdit(true)}>
          <Icon
            className="w-[15px] cursor-pointer"
            src="/images/icons/edit.svg"
          />
        </span>
      </div>
      <div className="mt-3 border p-4 ">
        <ViewRowInterchange
          dataSource={productDetail}
          keyList={DETAILS_KEY as any}
          variant="border"
          classNameLabel="text-hint "
          classNameContent="text-end "
        />
        {openEdit && (
          <ProductDetailSkuDrawer
            open={openEdit}
            onClose={() => setOpenEdit(false)}
            defaultValue={productDetail}
            onUpdated={loadProductDetail}
          />
        )}
      </div>
    </div>
  );
};

export default ProductDetailSku;
